import Guid from './Guid';

export default class IBaseModel {
  isDeleted: boolean = false;
  dateCreation: Date = new Date();
  dateModification: Date = new Date();
  dateSuppression: Date = new Date();
  description: string = '';
  idUsagerCreation: Guid = Guid.empty;
  idUsagerModification: Guid = Guid.empty;
  idUsagerSuppression: Guid = Guid.empty;
}